import { booleanParser, encodedStringParser } from '../inboundParsers';
export const SIDE_BET_DONE_PAYLOAD_DEFINITION = {
    definitionParts: [
        { name: 'isSuccess', parser: booleanParser },
        { name: 'errorMessage', parser: encodedStringParser }
    ]
};
